import { createNewandGetTagEndPoint } from "../../configuration";
import axiosInstance from "../../global/axiosInterceptor";
import { showNotificationBanner } from "../../store/actions";

export const getCityAndState = (tagIds, siteTagList) => {
    console.log("here d")
    if (siteTagList) {
      const parsedCities = siteTagList.cities;
      const parsedStates = siteTagList.states;

      let city = "";
      let state = "";

      tagIds?.forEach((tagId) => {
        const foundCity = parsedCities.find((city) => city.id === tagId);
        if (foundCity) {
          city = foundCity.name;
          const stateTagId = foundCity.tagids[0];
          const foundState = parsedStates.find(
            (state) => state.id === stateTagId
          );
          if (foundState) {
            state = foundState.name;
          }
        }
      });

      return { city, state };
    }
    return { city: "", state: "" };
  };

export const checkingStateAndCityExits = (siteTagList, stateName, cityName, countryName) => {
    try {
      // const tagData = JSON.parse(sessionStorage.getItem("TagIdsList"));
      const tagData = siteTagList;

      const countryTag = tagData.countries.find(
        (item) => item.name === countryName && item.kind === "ts.tag.country"
      );

      const stateTag = tagData.states.find(
        (item) =>
          item.name === stateName &&
          item.kind === "ts.tag.state" &&
          item.tagids.includes(countryTag?.id)
      );

      const cityTag = tagData.cities.find(
        (item) =>
          item.name === cityName &&
          item.kind === "ts.tag.city" &&
          item.tagids.includes(stateTag?.id)
      );

      return {
        countryExists: !!countryTag,
        stateExists: !!stateTag,
        cityExists: !!cityTag,
        countryId: countryTag ? countryTag.id : null,
        stateId: stateTag ? stateTag.id : null,
        cityId: cityTag ? cityTag.id : null,
      };
    } catch (e) {
      console.log("Error fetching country, state, or city tag", e);
      return {
        countryExists: false,
        stateExists: false,
        cityExists: false,
        countryId: null,
        stateId: null,
        cityId: null,
      };
    }
  };

  export const generatePayloadForMissingTags = (activeSession, stateName, cityName, countryId) => {
        const payload = {
          accountname: activeSession.accountId,
          tags: [
            {
              kind: "ts.tag.state",
              name: stateName,
              tagids: [countryId],
              nestedtags: [
                {
                  kind: "ts.tag.city",
                  name: cityName,
                },
              ],
            },
          ],
        };
        return payload;
      };

  export const createNewCityTag = async (payload) => {
      try {
        const response = await axiosInstance.post(
          createNewandGetTagEndPoint(),
          payload
        );

        const data = response?.data;
        return data;
      } catch (error) {
        console.error("Error creating new city tag:", error);
        throw error;
      }
  };

    export const processImageToGrayscaleBlob = (imageSrc) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        const imageData = ctx.getImageData(0, 0, img.width, img.height);
        for (let i = 0; i < imageData.data.length; i += 4) {
          const avg =
            (imageData.data[i] +
              imageData.data[i + 1] +
              imageData.data[i + 2]) /
            3;
          imageData.data[i] = avg;
          imageData.data[i + 1] = avg;
          imageData.data[i + 2] = avg;
        }
        ctx.putImageData(imageData, 0, 0);
        canvas.toBlob((blob) => {
          const objectUrl = URL.createObjectURL(blob);
          resolve({ blob, grayscaleImageUrl: objectUrl });
        }, "image/png");
      };
      img.onerror = (error) => reject(error);
      img.src = imageSrc;
    });
  }; 

    export async function deleteFloorPlan({
      mode,
      id,
      index,
      values,
      activeSession,
      deleteMediaFn,
      handleSiteDeleteFn,
      dispatch,
      deleteFloorImageMappingAction,
      cb,
    }) {
      if (mode === "edit") {
        try {
          const fileMeta = values.files[index];
          const mediaId = !fileMeta.id ? fileMeta.imageid : fileMeta.image ? fileMeta.image : fileMeta.imageid;
          const siteDeleteRes = await handleSiteDeleteFn(id, activeSession);
         
            
            if (siteDeleteRes === "" && id) {
                const response = await deleteMediaFn(mediaId, activeSession);
                if (response.status === 200) {
                  dispatch(deleteFloorImageMappingAction(id));
                  cb();
                }
          }
        } catch (error) {
          console.error("Error deleting image:", error);
          dispatch(showNotificationBanner({
            type: "Floor delete error",
            priority: "critical",
            data: {
              title: "Floor plan failed to delete",
              subTitle: "Please try again",
            },
            showNotification: true,
          }));
        }
      } else {
        cb();
      }
    }

    export const handleDeleteAreaSubArea = (index, values, clearFormSiteTagList, setFieldValue) => {
      values.sites[index]?.areas?.forEach((area) => {
        if (area.id) {
          clearFormSiteTagList(area.id, "areas");
          area.subAreas?.forEach((subArea) => {
            if (subArea.id) {
              clearFormSiteTagList(subArea.id, "subareas");
            }
          });
        }
      });
      setFieldValue(
        "sites",
        values.sites.filter((s, sI) => sI !== index)
      );
    };

    export const validateNameField = (value) => {
      if (!value) return true; // Allow empty values (required validation is handled separately)

      // Regex pattern:
      // ^[a-zA-Z0-9\-_#]+ - Start with alphanumeric, -, _, or #
      // ( [a-zA-Z0-9\-_#]+)* - Optionally followed by single space and more valid characters
      // ( )?$ - Allow optional trailing space (will be trimmed when using the value)
      const namePattern = /^[a-zA-Z0-9\-_#]+( [a-zA-Z0-9\-_#]+)*( )?$/;

      return namePattern.test(value);
    };

    // Trim trailing space from validated name field before using the value
    export const trimNameField = (value) => {
      return value ? value.trim() : value;
    };

